export const AI_BLOCK_CONSTANTS = {
  AI_BLOCK_TYPES: {
    HELP_WRITE: "help_write",
    SUGGEST_IDEA: "suggest_ideas",
    CONCLUSION: "conclusion",
    OUTLINE: "outline",
  },
  GENERATED_BLOCK_HEIGHT: 24,
};
